import { render, staticRenderFns } from "./ManageIncident.vue?vue&type=template&id=027f3d60&scoped=true"
import script from "./ManageIncident.vue?vue&type=script&lang=js"
export * from "./ManageIncident.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027f3d60",
  null
  
)

export default component.exports